import { render, staticRenderFns } from "./SMSTable.vue?vue&type=template&id=adfd975e&"
import script from "./SMSTable.vue?vue&type=script&lang=js&"
export * from "./SMSTable.vue?vue&type=script&lang=js&"
import style0 from "./SMSTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports